import { openDB as openIDB } from 'idb';
import type { Vessel, Survey } from '../types';

const DB_NAME = 'draft-survey-db';
const DB_VERSION = 1;

async function openDraftDB() {
  return await openIDB(DB_NAME, DB_VERSION, {
    upgrade(db: any) {
      if (!db.objectStoreNames.contains('vessels')) db.createObjectStore('vessels', { keyPath: 'id' });
      if (!db.objectStoreNames.contains('surveys')) {
        const s = db.createObjectStore('surveys', { keyPath: 'id' });
        s.createIndex('by-vessel', 'vessel_id');
      }
    },
  });
}

export async function getLocalVessels(): Promise<Vessel[]> {
  const db = await openDraftDB();
  return (await db.getAll('vessels')) as Vessel[];
}

export async function saveLocalVessel(vessel: Vessel): Promise<void> {
  const db = await openDraftDB();
  await db.put('vessels', vessel as any);
}

export async function deleteLocalVessel(id: string): Promise<void> {
  const db = await openDraftDB();
  await db.delete('vessels', id);
}

export async function getLocalSurveys(vesselId?: string): Promise<Survey[]> {
  const db = await openDraftDB();
  if (vesselId) {
    return (await db.getAllFromIndex('surveys', 'by-vessel', vesselId)) as Survey[];
  }
  return (await db.getAll('surveys')) as Survey[];
}

export async function saveLocalSurvey(survey: Survey): Promise<void> {
  const db = await openDraftDB();
  await db.put('surveys', survey as any);
}

export async function deleteLocalSurvey(id: string): Promise<void> {
  const db = await openDraftDB();
  await db.delete('surveys', id);
}

export async function clearAllLocal(): Promise<void> {
  const db = await openDraftDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['vessels', 'surveys'], 'readwrite');
    tx.objectStore('vessels').clear();
    tx.objectStore('surveys').clear();
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

// Aliases for backward compatibility with useVessels.ts and App.tsx
export const getVesselsLocal = getLocalVessels;
export const saveVesselLocal = saveLocalVessel;
export const deleteVesselLocal = deleteLocalVessel;
export const getSurveysLocal = getLocalSurveys;
export const saveSurveyLocal = saveLocalSurvey;
export const deleteSurveyLocal = deleteLocalSurvey;
